import Base from 'front/components/Base/Base';

import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

import {VIEWPORT_EVENTS, WINDOW_BREAKPOINT} from '../../../constants/Constants';

import './Storyboards.less';
import * as _ from 'underscore';

const Selectors = {
    el: '.IndexStoryboards'
};

const BindFunctions = [
    'onResize',
    'initSlider'
];

export default class Intro extends Base {
    constructor() {
        super({el: Selectors.el});
        _.bindAll(this, BindFunctions);

        this.onResize();
        $(window).on(VIEWPORT_EVENTS.resize, this.onResize);
    }

    onResize() {
        let ww = window.innerWidth;
        if (WINDOW_BREAKPOINT.widthBreakpoint >= ww) {
            this.initSlider();
        } else {
            if (this.swiper !== undefined) {
                this.swiper.destroy(true, true);
            }
        }
    }

    initSlider() {
        this.swiper = new Swiper($(Selectors.el).find('.swiper-container')[0], {
            slidesPerView: 'auto',
            slidesPerColumn: 2,
            freeMode: true
        });
    }
}
